import { Dispatch } from 'react'
import { showModal, hideModal } from './actions'
import { ModalActions } from './types'

export const setActiveModal = name => {
  return (dispatch: Dispatch<ModalActions>) => {
    dispatch(showModal(name))
  }
}

export const hideModals = () => {
  return (dispatch: Dispatch<ModalActions>) => {
    dispatch(hideModal())
  }
}
